export default {
   light: 'rgba(130, 141, 150, 0.25)',
   heavy: 'rgba(130, 141, 150, 0.5)',
};
